import { Map as ImmutableMap, Record, type RecordOf } from 'immutable';

import type { QcsSyncResourceStore, QcsSyncResourceStoreProps } from 'app-components/flux/core/resourceStoreTypes';

export const A2A_TRANSFERS_REDUCER_KEY = 'a2aTransfersStore';

export type TransferStatus =
  | 'REJECTED'
  | 'SUBMITTED'
  | 'SCHEDULED'
  | 'IN_PROGRESS'
  | 'COMPLETED'
  | 'FAILED'
  | 'CANCELLED';

export type A2aTransferProps = {
  id: string;
  status?: TransferStatus;
  sourceFundingAccount: {
    id: string;
  };
  destinationFundingAccount: {
    id: string;
  };
  amount: string;
  initiateOn?: string; // maybe no longer needed
  arriveOn?: string; // maybe no longer needed
  zoneId: string;
  schedule: {
    startOn: string;
    completeOn: string;
  };
  execution: {
    startedOn: string;
    completedOn?: string;
    failedOn?: string;
    cancelledOn?: string;
  };
  additionalInfo?: {
    code?: string;
    description?: string;
    details?: {
      externalCode?: string;
      code?: string;
      errorCode?: string;
      description?: string;
    }[];
  };
  settlement?: {
    code?: string;
    description?: string;
    details?: {
      status?: string;
      type?: string;
      amount?: number;
      partial?: boolean;
    };
  };
};

export type A2aTransfer = RecordOf<A2aTransferProps>;
const A2aTransferRecord = Record<A2aTransferProps>({
  id: '',
  status: undefined,
  sourceFundingAccount: { id: '' },
  destinationFundingAccount: { id: '' },
  amount: '',
  initiateOn: undefined,
  arriveOn: undefined,
  zoneId: '',
  schedule: {
    startOn: '',
    completeOn: '',
  },
  execution: {
    startedOn: '',
    completedOn: undefined,
    failedOn: undefined,
    cancelledOn: undefined,
  },
  additionalInfo: undefined,
  settlement: undefined,
});

export const mkA2aTransfer = (props: A2aTransferProps): A2aTransfer => A2aTransferRecord(props);

// store
export type A2aTransferStoreProps = QcsSyncResourceStoreProps<A2aTransferProps>;
export type A2aTransferStore = QcsSyncResourceStore<A2aTransferProps, A2aTransferStoreProps>;
export const mkA2aTransferStore = Record<A2aTransferStoreProps>({
  resourcesById: ImmutableMap(),

  resourceName: 'a2aTransfers',
  lastSyncDate: null,
  loadPending: true,
  isLoading: false,
  error: undefined,
});

declare module 'app-components/utils/redux-store/rootState' {
  export default interface RootState {
    [A2A_TRANSFERS_REDUCER_KEY]: A2aTransferStore;
  }
}
